import { useParams } from 'react-router-dom';
import { invariant } from 'shared/utils/utils';
import { RenderUnsettledUI, SmallError, SmallLoader } from 'shared/components';
import { EditDocumentFormDataProvider } from './edit-document-form-provider/edit-document-form-data-provider';
import { useGetDocumentDetails } from '../documents-page/table/hooks/use-get-document-details';

export const EditDocument = () => {
  const { documentId } = useParams<'documentId'>();
  invariant(documentId, 'DocumentId id is missing');

  const documentDetailQuery = useGetDocumentDetails(documentId);

  if (documentDetailQuery.status !== 'success') {
    return (
      <RenderUnsettledUI
        renderLoading={() => <SmallLoader />}
        renderError={(error) => <SmallError error={error} />}
        data={documentDetailQuery}
      />
    );
  }

  return <EditDocumentFormDataProvider documentData={documentDetailQuery.data} />;
};
